import moment from "moment";
import { extractDuration } from "smash-time";
import { GetPlanGroupOutput } from '@smash-sdk/billing/ejs/01-2024/types/GetPlanGroup/GetPlanGroup';
import { ListCountriesOutput } from "@smash-sdk/vat/ejs/10-2019/vat";

export function computeDiscountPercentage({ plan, countryCurrency, plans }: { plan: GetPlanGroupOutput['group']['plans'][0], countryCurrency: ListCountriesOutput['countries'][0]['currency'], plans: GetPlanGroupOutput['group']['plans'] }): number {
    const { quantity, unit } = extractDuration(plan.duration);
    const months = moment.duration(quantity, unit).asMonths();
    const monthlyPlan = plans.find(plan => plan.currency === countryCurrency && plan.duration === '1months');
    const discount = Math.floor(100 - ((100 / (monthlyPlan.priceExclTax * months)) * plan.priceExclTax));
    return discount;
}

export function computeOffer({ plan }: { plan: GetPlanGroupOutput['group']['plans'][0] }): { offer: number, currency: GetPlanGroupOutput['group']['plans'][0]['currency'] } {
    const { currency, priceExclTax } = plan;
    const shouldRoundOffer = currency === 'inr';
    if (!shouldRoundOffer) {
        return { offer: priceExclTax / 24, currency };
    }
    return { offer: Math.floor(plan.priceExclTax / 24), currency };
}